(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["promiseSettled"] = factory();
	else
		root["promiseSettled"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	/**
	 * @licence
	 * @author Sergey Melyukov 2016
	 */
	
	/**
	 * Waiting while all promises will be settled to onFulfilled or onRejected state
	 * Returned promise will be resolved with array with info for every passed promise:
	 * Array<{status:boolean, value:*}>
	 *
	 * onProgress-function will be called (if passed) for every settled promise
	 *
	 * @param {Array<Promise>} promises
	 * @param {function({status:boolean, value:*})=} onProgress
	 *
	 * @return {Promise}
	 */
	function allSettled(promises, onProgress) {
	    var mapped = promises.map(function(promise) {
	        return promise.then(function(value) {
	            return {
	                value: value,
	                status: true
	            };
	        }, function(e) {
	            return {
	                value: e,
	                status: false
	            };
	        }).then(function(value) {
	            if (typeof onProgress === 'function') {
	                onProgress(value);
	            }
	
	            return value;
	        });
	    });
	
	    return Promise.all(mapped);
	}
	
	module.exports = allSettled;


/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** promiseSettled.min.js
 **/